<div class="pingone-modal">
  <!-- Header -->
  <div class="modal-header">
    <div class="header-content">
      <mat-icon class="header-icon">account_circle</mat-icon>
      <div class="header-text">
        <h2>PingOne Accounts</h2>
        <span class="patient-name">{{ data.patientName }}</span>
        <span class="account-count" *ngIf="pingUsers.length > 0">{{ pingUsers.length }} account{{ pingUsers.length > 1 ? 's' : '' }} found</span>
      </div>
    </div>
    <button class="close-btn" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Success Toast -->
  <div class="success-toast" *ngIf="saveSuccess">
    <mat-icon>check_circle</mat-icon>
    <span>Changes saved successfully</span>
  </div>

  <!-- Error Toast -->
  <div class="error-toast" *ngIf="saveError">
    <mat-icon>error</mat-icon>
    <span>{{ saveError }}</span>
  </div>

  <!-- Body -->
  <div class="modal-body">
    <!-- No Account Found State -->
    <div class="no-account" *ngIf="pingUsers.length === 0">
      <mat-icon>person_off</mat-icon>
      <h3>No PingOne Accounts Found</h3>
      <p>No PingOne accounts are associated with this patient (MPI: {{ data.patientMpi }}).</p>
    </div>

    <!-- Accounts List -->
    <div class="accounts-list" *ngIf="pingUsers.length > 0">
      <div
        class="account-item"
        *ngFor="let user of pingUsers; let i = index"
        [class.expanded]="isExpanded(i)"
        [class.editing]="isEditing(i)">

        <!-- Account Header (clickable to expand/collapse) -->
        <div class="account-header" (click)="toggleAccount(i)">
          <div class="account-header-left">
            <div class="account-summary">
              <span class="summary-name">{{ user.firstName || '—' }} {{ user.lastName || '—' }}</span>
              <span class="summary-divider">|</span>
              <span class="summary-item"><span class="summary-label">DOB:</span> {{ user.dob ? formatDate(user.dob) : '—' }}</span>
              <span class="summary-divider">|</span>
              <span class="summary-item"><span class="summary-label">MPI:</span> {{ user.mpi || '—' }}</span>
              <span class="summary-divider">|</span>
              <span class="summary-item"><span class="summary-label">Email:</span> {{ user.email || '—' }}</span>
            </div>
          </div>
          <div class="account-header-right">
            <span class="status-badge" [ngClass]="getStatusClass(user)">{{ getStatusLabel(user) }}</span>
            <mat-icon class="expand-icon">{{ isExpanded(i) ? 'expand_less' : 'expand_more' }}</mat-icon>
          </div>
        </div>

        <!-- Account Details (shown when expanded, hidden when editing) -->
        <div class="account-details" *ngIf="isExpanded(i) && !isEditing(i)">
          <div class="details-grid">
            <div class="detail-item">
              <span class="label">MPI</span>
              <span class="value identifier">{{ user.mpi || '—' }}</span>
            </div>
            <div class="detail-item">
              <span class="label">Email</span>
              <span class="value">{{ user.email || '—' }}</span>
            </div>
            <div class="detail-item">
              <span class="label">Mobile Phone</span>
              <span class="value">{{ user.mobilePhone || '—' }}</span>
            </div>
            <div class="detail-item">
              <span class="label">Primary Phone</span>
              <span class="value">{{ user.primaryPhone || '—' }}</span>
            </div>
            <div class="detail-item">
              <span class="label">Username</span>
              <span class="value">{{ user.username || '—' }}</span>
            </div>
            <div class="detail-item">
              <span class="label">External ID</span>
              <span class="value identifier">{{ user.externalId || '—' }}</span>
            </div>
            <div class="detail-item" *ngIf="user.firstName || user.lastName">
              <span class="label">Name</span>
              <span class="value">{{ user.firstName }} {{ user.lastName }}</span>
            </div>
            <div class="detail-item" *ngIf="user.dob">
              <span class="label">Date of Birth</span>
              <span class="value">{{ formatDate(user.dob) }}</span>
            </div>
          </div>

          <div class="account-actions">
            <button class="action-btn secondary disabled-soon" *ngIf="user.status === 'active'" disabled title="Coming Soon">
              <mat-icon>lock</mat-icon>
              Lock <span class="soon-badge">Soon</span>
            </button>
            <button class="action-btn secondary disabled-soon" *ngIf="user.status === 'locked'" disabled title="Coming Soon">
              <mat-icon>lock_open</mat-icon>
              Unlock <span class="soon-badge">Soon</span>
            </button>
            <button class="action-btn secondary disabled-soon" disabled title="Coming Soon">
              <mat-icon>lock_reset</mat-icon>
              Reset Password <span class="soon-badge">Soon</span>
            </button>
            <button class="action-btn primary" (click)="startEdit(i); $event.stopPropagation()">
              <mat-icon>edit</mat-icon>
              Edit
            </button>
          </div>
        </div>

        <!-- Edit Form (shown when editing) -->
        <div class="edit-form" *ngIf="isEditing(i)">
          <form [formGroup]="getEditForm(i)!" class="edit-form-content">
            <div class="edit-form-grid">
              <div class="form-group">
                <label for="mpi-{{i}}">MPI</label>
                <input type="text" id="mpi-{{i}}" formControlName="mpi" placeholder="Enter MPI">
              </div>
              <div class="form-group">
                <label for="email-{{i}}">Email</label>
                <input type="email" id="email-{{i}}" formControlName="email" placeholder="Enter email">
              </div>
              <div class="form-group">
                <label for="mobilePhone-{{i}}">Mobile Phone</label>
                <input type="tel" id="mobilePhone-{{i}}" formControlName="mobilePhone" placeholder="Enter mobile phone">
              </div>
              <div class="form-group">
                <label for="primaryPhone-{{i}}">Primary Phone</label>
                <input type="tel" id="primaryPhone-{{i}}" formControlName="primaryPhone" placeholder="Enter primary phone">
              </div>
            </div>
            <div class="edit-form-actions">
              <button type="button" class="action-btn secondary" (click)="cancelEdit(); $event.stopPropagation()" [disabled]="isSaving">
                <mat-icon>close</mat-icon>
                Cancel
              </button>
              <button type="button" class="action-btn primary" (click)="saveChanges(i); $event.stopPropagation()" [disabled]="getEditForm(i)?.invalid || isSaving">
                <mat-icon *ngIf="!isSaving">save</mat-icon>
                <span *ngIf="!isSaving">Save Changes</span>
                <span *ngIf="isSaving" class="saving">
                  <span class="spinner"></span>
                  Saving...
                </span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="modal-footer">
    <button class="close-modal-btn" (click)="close()">Close</button>
  </div>
</div>
